"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
// import { OmniChatSchema } from './Schema'
class Address extends Parse.Object {
    constructor(attributes) {
        super('Address', attributes);
    }
    /** A name that identifies the place. i.e.: Casa, Sede */
    get name() { return this.get('name'); }
    set name(value) { this.set('name', value); }
    get addressLine1() { return this.get('addressLine1'); }
    set addressLine1(value) { this.set('addressLine1', value); }
    get addressLine2() { return this.get('addressLine2'); }
    set addressLine2(value) { this.set('addressLine2', value); }
    get number() { return this.get('number'); }
    set number(value) { this.set('number', value); }
    get suburb() { return this.get('suburb'); }
    set suburb(value) { this.set('suburb', value); }
    get text() { return this.get('text'); }
    set text(value) { this.set('text', value); }
    get zipcode() { return this.get('zipcode'); }
    set zipcode(value) { this.set('zipcode', value); }
    get state() { return this.get('state'); }
    set state(value) { this.set('state', value); }
    get type() { return this.get('type'); }
    set type(value) { this.set('type', value); }
    /**
     * Three letter country code
     * Format ISO 3166-1
     * Example for Brasil the code is BRA
     */
    get city() { return this.get('city'); }
    set city(value) { this.set('city', value); }
    get addressState() { return this.get('addressState'); }
    set addressState(value) { this.set('addressState', value); }
    get country() { return this.get('country'); }
    set country(value) { this.set('country', value); }
    get zip() { return this.get('zip'); }
    set zip(value) { this.set('zip', value); }
    get recipient() { return this.get('recipient'); }
    set recipient(value) { this.set('recipient', value); }
    get team() { return this.get('team'); }
    set team(value) { this.set('team', value); }
}
exports.Address = Address;
Parse.Object.registerSubclass('Address', Address);
//# sourceMappingURL=Address.js.map